import React, { useState } from "react";
import { Link } from "react-router-dom";
import { getConsent, setConsent } from "@/lib/consent";

// Banner proprio per i cookie tecnici e il consenso pubblicitario.
// Con ADS_MODE = "adsense" Google mostrerà anche il messaggio della sua CMP certificata ("Privacy e messaggi").
export default function CookieConsent() {
  const [open, setOpen] = useState(() => !getConsent());
  if (!open) return null;
  const choose = (ads) => { setConsent({ ads }); setOpen(false); };
  return (
    <div data-testid="cookie-consent" className="fixed bottom-3 inset-x-3 sm:inset-x-auto sm:right-4 sm:max-w-sm z-[60] bg-white border border-[#DADFEA] rounded-2xl shadow-lg p-4">
      <p className="text-sm text-[#2A2E48]">
        Usiamo cookie tecnici necessari per l'accesso e la navigazione. Con il tuo consenso potremo usare anche cookie pubblicitari di Google e di terze parti. Leggi la{" "}
        <Link to="/privacy" data-testid="cookie-privacy-link" className="text-[#141A3A] underline">Privacy</Link>{" "}
        e la <Link to="/cookie" data-testid="cookie-policy-link" className="text-[#141A3A] underline">Cookie Policy</Link>.
      </p>
      <div className="mt-3 flex gap-2">
        <button data-testid="cookie-reject" onClick={() => choose(false)} className="flex-1 h-10 rounded-full border border-[#DADFEA] text-[#0F1230] text-sm font-bold">Solo necessari</button>
        <button data-testid="cookie-accept" onClick={() => choose(true)} className="flex-1 h-10 rounded-full bg-[#1F4FE0] text-white text-sm font-bold">Accetta tutti</button>
      </div>
    </div>
  );
}
